import type { User } from 'oidc-client-ts';
import type { MpaHandoffTokenBundle } from '@/types/mpaHandoff';

const DEFAULT_MPA_TOKEN_SCOPE = import.meta.env.VITE_COGNITO_SCOPE ?? 'openid email profile';

export const buildMpaTokenFragment = ({
  accessToken,
  idToken,
  refreshToken,
  expiresIn,
  tokenType,
  scope,
}: MpaHandoffTokenBundle): string => {
  const params = new URLSearchParams({
    access_token: accessToken,
    id_token: idToken,
    refresh_token: refreshToken,
    expires_in: String(expiresIn),
    token_type: tokenType,
    scope,
  });

  return params.toString();
};

export const buildMpaTokenFragmentFromOidcUser = (user: User): string | null => {
  if (!user.access_token || !user.id_token || !user.refresh_token) {
    return null;
  }

  if (!user.expires_at) {
    return null;
  }

  const expiresIn = Math.max(0, user.expires_at - Math.floor(Date.now() / 1000));

  return buildMpaTokenFragment({
    accessToken: user.access_token,
    idToken: user.id_token,
    refreshToken: user.refresh_token,
    expiresIn,
    tokenType: user.token_type || 'Bearer',
    scope: user.scope || DEFAULT_MPA_TOKEN_SCOPE,
  });
};

export const redirectToMpaHandoff = ({
  loginUrl,
  state,
  tokenFragment,
}: {
  loginUrl: string;
  state: Record<string, string>;
  tokenFragment: string;
}): void => {
  const redirectUrl = new URL(loginUrl);
  redirectUrl.searchParams.set('state', JSON.stringify(state));
  redirectUrl.hash = tokenFragment;
  window.location.assign(redirectUrl.toString());
};
